import {
  SIDEBAR_CLOSE,
  SIDEBAR_OPEN,
} from '../actiontypes/sidebar';

const INITIAL_STATE = {
  isOpen: false,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SIDEBAR_OPEN:
      return { isOpen: true };
    case SIDEBAR_CLOSE:
      return { isOpen: false };
    default:
      return state;
  }
}
